module.exports = __webpack_public_path__ + "img/TZS09520.92b1c1ca.jpeg";